<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-4 sm:px-8 flex flex-col h-full w-full py-4 sm:py-8">

                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/alumni-management" class="opacity-50 hover:opacity-100">Alumni</router-link>
                        <span class="mx-2">/</span>
                        <span v-if="role == 'partner'">Alumni List</span>
                        <span v-else>Registered Alumni</span>
                    </div>
                    <div v-if="role == 'partner'" class="font-bold">Alumni List</div>
                    <div v-else class="font-bold">Registered Alumni</div>
                </div>

                <div class="mt-4 flex justify-end items-center">
                    <div v-if="isExportExcel"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
                        <base-spinner-with-text class-list="w-4 h-4" text=""
                            text-class-list="text-white"></base-spinner-with-text>
                        <span class="text-xs">Exporting Excel</span>
                    </div>
                    <div v-else @click="generateReport"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                        <span class="text-xs ml-2">Export Excel</span>
                    </div>
                </div>

                <section class="mt-4 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap">
                        <h1 v-if="role == 'partner'" class="text-base md:text-lg font-semibold text-ternary mb-4">Alumni
                            List</h1>
                        <h1 v-else class="text-base md:text-lg font-semibold text-ternary mb-4">Registered Alumni List
                        </h1>
                        <div class="flex justify-start items-center flex-wrap mb-4">
                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Entity:</div>
                                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item.entity" v-for="(item, index) in filteredEntities" :key="index">
                                        {{ item.entity }}</option>
                                </select>
                            </div>
                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Local or Non Local:</div>
                                <select v-model="filterByLocalOrNonLocal" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Local">Local</option>
                                    <option value="Non Local">Non Local</option>
                                </select>
                            </div>
                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Employment Status:</div>
                                <select v-model="filterByEmploymentStatus" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="1">Employed</option>
                                    <option value="0">Unemployed</option>
                                    <option value="nil">Not Contacted</option>
                                </select>
                            </div>
                            <div class="w-full sm:w-auto mb-4">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col -mt-4" v-if="$apollo.queries.applications.loading">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <div class="min-w-full text-left text-sm font-light">
                                        <div class="border-b font-medium dark:border-neutral-500">
                                            <div class="flex">
                                                <div class="px-6 py-2 text-gray-400 w-12 lg:w-16">#</div>
                                                <div class="flex-grow px-6 py-2 text-gray-400">
                                                    <div class="w-32 md:w-auto">Name</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Entity</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">School ID</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Emirates ID</div>
                                                </div>
                                                <div v-if="role == 'admin' || role == 'superadmin' || role == 'supervisor'"
                                                    class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Career Counselor Status Status</div>
                                                </div>
                                                <div v-if="role == 'admin'" class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Supervisor Status</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400 w-24 lg:w-40">Actions</div>
                                            </div>
                                        </div>
                                        <div>
                                            <student-tile-shimmer v-for="(sts, index) in first"
                                                :key="index"></student-tile-shimmer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!$apollo.queries.applications.loading && filteredStudents.length <= 0"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No applications found!</h1>
                    </div>
                    <div v-else class="flex flex-col -mt-4">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Name</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Campus</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Student ID</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Emirates ID</th>
                                                <th v-if="role == 'admin' || role == 'superadmin' || role == 'supervisor'"
                                                    scope="col" class="px-6 py-2 text-gray-400">Career Counselor Status
                                                </th>
                                                <th v-if="role == 'admin'" scope="col" class="px-6 py-2 text-gray-400">
                                                    Supervisor Status</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(student, index) in filteredStudents" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex items-center">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img @click.stop="openPreviewImgModal(student.student_id, student.student_entity)"
                                                                class="h-12 w-12 rounded-lg object-cover cursor-pointer"
                                                                :src="getProfilePicture(student.profile_picture_url, student.student_id, student.student_entity)"
                                                                alt="">
                                                        </div>
                                                        <div class="flex-grow flex flex-col mr-4">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span
                                                                    @click.stop="viewStudentProfile(student.student_id)"
                                                                    class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                                                        student.name_en }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400">{{ student.user.email }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getEntityName(student.student_entity) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ student.campus_code }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ student.student_id }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ student.eid }}</td>
                                                <td v-if="role == 'admin' || role == 'superadmin' || role == 'supervisor'"
                                                    class="whitespace-nowrap px-6 py-2"
                                                    v-html="getApplicationStatus(student.user, 'careercounselor')"></td>
                                                <td v-if="role == 'admin'" class="whitespace-nowrap px-6 py-2"
                                                    v-html="getApplicationStatus(student.user, 'supervisor')"></td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('applications-show')"
                                                            @click.stop="viewStudentProfile(student.student_id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <div v-if="role == 'admin' || role == 'superadmin'"
                                                            class="flex">
                                                            <div v-if="isShowApproveBtn(student.user)"
                                                                @click.stop="approveBtnClicked(student.user.id)"
                                                                class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                                <icon-approve
                                                                    class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                                            </div>
                                                            <div v-if="isShowRejectBtn(student.user)"
                                                                @click.stop="rejectBtnClicked(student.user.id)"
                                                                class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                                                                <icon-reject
                                                                    class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="showAddNote" title="Do you want to reject this application?"
                            @close="closeAddNote">
                            <div class="flex flex-col">
                                <label for="note" class="px-8 mt-4 text-sm ml-1">Add Your Note</label>
                                <div class="h-32 px-8 rounded-xl mt-2">
                                    <textarea v-model="note" placeholder="Type your comments here..."
                                        class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                                </div>
                                <div class="flex justify-between mt-4 mx-8">
                                    <div @click.stop="closeAddNote"
                                        class="border-2 font-medium border-ternary text-ternary hover:text-white bg-white hover:bg-ternary rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        Cancel</div>
                                    <div @click.stop="addNoteOk"
                                        class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        Confirm</div>
                                </div>
                            </div>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="openviewStudentModal" :title="`Student Details - ${modalTitle}`"
                            height="805px" @close="closeViewStudentModal">
                            <student-view :student-id="studentId" @student-verified="onStudentVerified"></student-view>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="editStudentModal" :title="`Edit Student Details - ${modalTitle}`"
                            height="871px" @close="closeEditStudentModal">
                            <student-edit :student-id="studentId" @update-student="onUpdateStudent"></student-edit>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="previewImageModal" title="" height="50vh" @close="closePreviewImageModal">
                            <img class="h-full w-full object-contain" :src="previewImg" />
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showStudentProfileFullModal" title="Student Profile"
                            @close="closeFullModal">
                            <student-profile :student-id="studentId"></student-profile>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading || isExportExcel">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import StudentTileShimmer from '../../components/students/StudentTileShimmer.vue';
import Search from "../../components/shared/search.vue";
import StudentView from "./view.vue";
import StudentEdit from "./edit.vue";
import StudentProfile from "../student-profile/index.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";
export default {
    name: "registered-alumni-index",
    components: {
        IconEye,
        IconApprove,
        IconReject,
        Pagination,
        StudentTileShimmer,
        Search,
        StudentView,
        StudentEdit,
        StudentProfile,
    },
    data() {
        return {
            applications: [],
            first: 10,
            page: 1,
            editStudentModal: false,
            openviewStudentModal: false,
            modalTitle: "",
            studentId: null,
            searchText: "",
            filterByEntity: "",
            filterByLocalOrNonLocal: "",
            filterByEmploymentStatus: "",
            previewImageModal: false,
            previewImg: "",
            showStudentProfileFullModal: false,
            entities: [],
            selectedAlumniUserId: null,
            status: null,
            showAddNote: false,
            note: "",
            isLoading: false,
            isExportExcel: false,
            isApiCallRecurisive: false,
            generatedReport: [],
        };
    },
    watch: {
        searchText() {
            this.page = 1;
        },
        filterByEntity() {
            this.page = 1;
        },
        filterByLocalOrNonLocal() {
            this.page = 1;
        },
        filterByEmploymentStatus() {
            this.page = 1;
        },
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        filteredStudents() {
            return this.applications.data;
        },
        paginatorInfo() {
            return this.applications.paginatorInfo;
        },
        filteredEntities() {
            return this.entities.data;
        },
    },
    apollo: {
        entities() {
            return {
                query: gql`query GetEntityList {
                    entities {
                        data {
                            entity
                        }
                    }
                }`,
                fetchPolicy: 'cache-and-network',
            }
        },
        applications() {
            return {
                query: gql`query GetAllApplications($first: Int!, $page: Int!, $search: String, $entity: String, $local_or_non_local: String, $is_employed: String, $student_status: String) {
                    applications(first: $first, page: $page, search: $search, entity: $entity, local_or_non_local: $local_or_non_local, is_employed: $is_employed, student_status: $student_status) {
                        data {
                            name_ar
                            name_en
                            student_id
                            student_entity
                            eid
                            campus_code
                            user {
                                id
                                email
                                is_verified_by_careercounselor
                                is_confirmed_by_supervisor
                                career_counselor_approval {
                                    career_counselor_name
                                    career_counselor_email
                                }
                                supervisor_approval {
                                    supervisor_name
                                    supervisor_email
                                }
                            }
                            profile_picture_url
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        search: this.searchText,
                        entity: this.filterByEntity,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        is_employed: this.filterByEmploymentStatus,
                        student_status: 'IG'
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        setPage(page) {
            this.page = page;
        },
        closeModal() {
            //this.showModal = false;
        },
        onUpdateStudent() {
            // this.$apollo.queries.students.refetch();

            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'success',
                title: 'Student Details Updated Successfully'
            })


            this.closeEditStudentModal();
        },
        onStudentVerified(status) {
            this.$apollo.queries.applications.refetch();

            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })

            if (status) {
                Toast.fire({
                    icon: 'success',
                    title: 'Application approved!'
                })
            } else {
                Toast.fire({
                    icon: 'success',
                    title: 'Application rejected!'
                })
            }

            this.closeViewStudentModal();
        },
        viewStudent(id, name) {
            if (this.role == 'admin' || this.role == 'superadmin' || this.role == 'partner') {
                this.viewStudentProfile(id);
            } else {
                this.studentId = id;
                this.modalTitle = name;
                this.openviewStudentModal = true;
            }
        },
        closeViewStudentModal() {
            this.openviewStudentModal = false;
            this.modalTitle = "";
            this.studentId = null;
        },
        editStudent(id, name) {
            this.studentId = id;
            this.modalTitle = name;
            this.editStudentModal = true;
        },
        closeEditStudentModal() {
            this.editStudentModal = false;
            this.modalTitle = "";
            this.studentId = null;
        },
        getProfilePicture(profilePictureUrl, studentId, entity) {
            if (profilePictureUrl) {
                if (profilePictureUrl == '/storage/alumni-profile-pictures/default-avatar.jpg') {
                    return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
                } else {
                    return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
                }
            } else {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            }
        },
        onSearch(searchText) {
            this.searchText = searchText;
        },
        openPreviewImgModal(studentId, entity) {
            this.previewImageModal = true;
            this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
        },
        closePreviewImageModal() {
            this.previewImageModal = false;
            this.previewImg = "";
        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        getApplicationStatus(user, role) {
            if (role == 'supervisor') {
                if (user.is_confirmed_by_supervisor === null) {
                    return `<div class="flex flex-col items-center"><div class="text-yellow-600">Not confirmed yet</div></div>`;
                } else {
                    if (user.supervisor_approval) {
                        return `<div class="flex flex-col items-center"><div class="text-green-600">Confirmed by</div><div>${user.supervisor_approval.supervisor_name}</div><div>(${user.supervisor_approval.supervisor_email})</div></div>`;
                    } else {
                        return `<div class="flex flex-col items-center"><div class="text-green-600">Confirmed</div></div>`;
                    }
                }
            } else {
                if (user.is_verified_by_careercounselor === null) {
                    return `<div class="flex flex-col items-center"><div class="text-yellow-600">Not verified yet</div></div>`;
                } else if (user.is_verified_by_careercounselor === false) {
                    if (user.career_counselor_approval) {
                        return `<div class="flex flex-col items-center"><div class="text-red-600">Rejected by</div><div>${user.career_counselor_approval.career_counselor_name}</div><div>(${user.career_counselor_approval.career_counselor_email})</div></div>`;
                    } else {
                        return `<div class="flex flex-col items-center"><div class="text-red-600">Rejected</div></div>`;
                    }
                } else {
                    if (user.career_counselor_approval) {
                        return `<div class="flex flex-col items-center"><div class="text-green-600">Approved by</div><div>${user.career_counselor_approval.career_counselor_name}</div><div>(${user.career_counselor_approval.career_counselor_email})</div></div>`;
                    } else {
                        return `<div class="flex flex-col items-center"><div class="text-green-600">Approved</div></div>`;
                    }
                }
            }
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showStudentProfileFullModal = true;
        },
        closeFullModal() {
            this.showStudentProfileFullModal = false;
            this.studentId = null;
        },
        isShowApproveBtn(user) {
            if (user.is_verified_by_careercounselor === null || user.is_confirmed_by_supervisor === null) {
                return true;
            } else {
                return false;
            }
        },
        isShowRejectBtn(user) {
            if (user.is_verified_by_careercounselor === null) {
                return true;
            } else {
                return false;
            }
        },
        approveBtnClicked(id) {
            this.updateApplicationByAdmin(id, true);
        },
        rejectBtnClicked(id) {
            this.selectedAlumniUserId = id;
            this.status = false;
            this.showAddNote = true;
        },
        addNoteOk() {
            this.showAddNote = false;
            this.updateApplicationByAdmin(this.selectedAlumniUserId, this.status);
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note = "";
            this.selectedAlumniUserId = null;
        },
        async updateApplicationByAdmin(id, status) {

            this.isLoading = true;

            const UPDATE_ALUMNI_APPLICATION_BY_ADMIN_MUTATION = gql`
                mutation UpdateAlumniApplicationByAdmin($id: ID!, $status: Boolean!, $note: String) {
                    updateAlumniApplicationByAdmin(id: $id, status: $status, note: $note) {
                        error
                        message
                    }
                }
            `;

            let error = null;
            let success = null;

            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_ALUMNI_APPLICATION_BY_ADMIN_MUTATION,
                    variables: {
                        id: parseInt(id),
                        status: status,
                        note: this.note,
                    }
                }).then((data) => {
                    if (data.data.updateAlumniApplicationByAdmin.error) {
                        error = data.data.updateAlumniApplicationByAdmin.message;
                    } else {
                        success = data.data.updateAlumniApplicationByAdmin.message;
                    }
                }).catch((err) => {
                    error = err
                })
            } catch (err) {
                error = err.message || "Failed to authenticate, try later.";
            }

            if (error === null) {
                this.showToast(success);
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.note = "";
                    }
                })
            }

            this.note = "";
            this.isLoading = false;

        },
        showToast(success) {
            this.$apollo.queries.applications.refetch();

            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: success
            })

        },
        async generateReport() {
            var page = 1;
            var limit = 200;
            this.isExportExcel = true;
            this.isApiCallRecurisive = true;
            while (this.isApiCallRecurisive) {
                const responseData = await this.fetchForExporting(page, limit);
                if (responseData.data.length > 0) {
                    this.generatedReport.push(
                        ...responseData.data.map((obj) => {
                            return {
                                student_id: obj.student_id,
                                eid: obj.eid,
                                name_en: obj.name_en,
                                name_ar: obj.name_ar,
                                entity: this.getEntityName(obj.entity),
                                campus: obj.campus_code,
                                program_name: this.getSpecialization(obj.entity, obj.study_program, obj.program_name, obj.program_code, obj.cluster_e),
                                alumni_phone: obj.alumni_phone || "",
                                primary_phone: obj.primary_phone || "",
                                secondary_phone: obj.secondary_phone || "",
                                primary_email: obj.primary_email || "",
                                secondary_email: obj.secondary_email || "",
                                local_or_non_local: obj.local_or_non_local,
                                academic_year: this.getAcademicYear(obj.academic_year, obj.ay),
                                grad_year: this.getGraduationYear(obj.grad_year, obj.academic_year_graduation),
                                is_employed: obj.is_employed ? "Yes" : "No",
                                employer: this.getEmployerName(obj.is_employed, obj.employmentInformations),
                                designation: this.getDesignation(obj.employmentInformations),
                                registered: this.isRegistered(obj.user_id),
                            };
                        })
                    );
                    page++;
                } else {
                    this.isApiCallRecurisive = false;
                    break;
                }
            }
            this.exportToExcel("Registered_Alumni_Students");
        },
        async fetchForExporting(pageNo = 1, limitSize = 50) {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GenerateRegisteredStudentsReport(
                            $page: Int
                            $limit: Int
                            $search: String
                            $entity: String
                            $student_status: String
                            $local_or_non_local: String
                            $is_employed: String
                        ) {
                            generateRegisteredStudentsReport(
                                page: $page
                                limit: $limit
                                search: $search
                                entity: $entity
                                student_status: $student_status
                                local_or_non_local: $local_or_non_local
                                is_employed: $is_employed
                            ) {
                                error
                                error_code
                                message
                                data {
                                    student_id
                                    user_id
                                    eid
                                    name_en
                                    name_ar
                                    entity
                                    campus_code
                                    program_name
                                    study_program
                                    program_code
                                    cluster_e
                                    primary_email
                                    secondary_email
                                    alumni_phone
                                    primary_phone
                                    secondary_phone
                                    local_or_non_local
                                    academic_year
                                    ay
                                    grad_year
                                    academic_year_graduation
                                    is_employed
                                    employmentInformations {
                                        employer
                                        position
                                        aprehis_empl_position
                                    }
                                }
                            }
                        }
                    `,
                    fetchPolicy: "network-only",
                    variables: {
                        page: pageNo,
                        limit: limitSize,
                        search: this.searchText,
                        entity: this.filterByEntity,
                        student_status: 'IG',
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        is_employed: this.filterByEmploymentStatus,
                    },
                });

                const responseData = data.generateRegisteredStudentsReport;
                return responseData;
            } catch (error) {
                console.log(error.message);
            }
        },
        exportToExcel(reportName) {
            const XLSX = xlsx;

            const header = [
                "STUDENT ID",
                "EID",
                "NAME IN ENGLISH",
                "NAME IN ARABIC",
                "ENTITY",
                "CAMPUS",
                "PROGRAM NAME",
                "ALUMNI PHONE",
                "PRIMARY PHONE",
                "SECONDARY PHONE",
                "PRIMARY EMAIL",
                "SECONDARY EMAIL",
                "LOCAL OR NON LOCAL",
                "ACADEMIC YEAR",
                "GRADUATED YEAR",
                "IS EMPLOYED",
                "EMPLOYER",
                "DESIGNATION",
                "IS REGISTERED",
            ];

            const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);

            worksheet["A1"] = { v: header[0], t: "s" };
            worksheet["B1"] = { v: header[1], t: "s" };
            worksheet["C1"] = { v: header[2], t: "s" };
            worksheet["D1"] = { v: header[3], t: "s" };
            worksheet["E1"] = { v: header[4], t: "s" };
            worksheet["F1"] = { v: header[5], t: "s" };
            worksheet["G1"] = { v: header[6], t: "s" };
            worksheet["H1"] = { v: header[7], t: "s" };
            worksheet["I1"] = { v: header[8], t: "s" };
            worksheet["J1"] = { v: header[9], t: "s" };
            worksheet["K1"] = { v: header[10], t: "s" };
            worksheet["L1"] = { v: header[11], t: "s" };
            worksheet["M1"] = { v: header[12], t: "s" };
            worksheet["N1"] = { v: header[13], t: "s" };
            worksheet["O1"] = { v: header[14], t: "s" };
            worksheet["P1"] = { v: header[15], t: "s" };
            worksheet["Q1"] = { v: header[16], t: "s" };
            worksheet["R1"] = { v: header[17], t: "s" };
            worksheet["S1"] = { v: header[18], t: "s" };

            worksheet["!cols"] = [
                { width: 40 },
                { width: 40 },
                { width: 30 },
                { width: 30 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 30 },
                { width: 20 },
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
            this.generatedReport = [];
            this.isExportExcel = false;
            this.isApiCallRecurisive = false;
        },
        getEntityName(entity) {
            if (entity == "ATHS") {
                return "ATS";
            } else {
                return entity;
            }
        },
        getSpecialization(entity, studyProgram, programName, programCode, clusterE) {
            let specialization = "";
            if (entity == "ATHS") {
                if (clusterE) {
                    specialization = clusterE;
                } else if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            } else {
                if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            }
            return specialization;
        },
        getAcademicYear(academicYear, AY) {
            if (academicYear) {
                return academicYear;
            } else if (AY) {
                return AY;
            } else {
                return "";
            }
        },
        getGraduationYear(gradYear, academicYearGraduation) {
            if (gradYear) {
                return gradYear;
            } else if (academicYearGraduation) {
                return academicYearGraduation;
            } else {
                return "";
            }
        },
        getEmployerName(isEmployed, employerInformation) {
            if (isEmployed) {
                if (employerInformation) {
                    return employerInformation.employer;
                } else {
                    return "Not Contacted";
                }
            } else {
                if (employerInformation) {
                    return employerInformation.employer;
                } else {
                    return "Unemployed";
                }
            }
        },
        getDesignation(employerInformation) {
            if (employerInformation) {
                if (employerInformation.position) {
                    return employerInformation.position;
                } else {
                    return employerInformation.aprehis_empl_position;
                }
            } else {
                return "";
            }
        },
        isRegistered(userId) {
            if (userId) {
                return "Yes";
            } else {
                return "No";
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

body.loading {
    filter: blur(5px);
}

#loading-overlay {
    background-color: rgba(0, 0, 0, 0.25);
}
</style>